module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "054a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextMedium_vue_vue_type_style_index_0_id_0f65208b_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ee41");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextMedium_vue_vue_type_style_index_0_id_0f65208b_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextMedium_vue_vue_type_style_index_0_id_0f65208b_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "06a9":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".text__medium[data-v-0f65208b]{font-size:14px;font-weight:400;line-height:1.36;letter-spacing:normal}.text__medium.bold[data-v-0f65208b]{font-weight:700}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "1e73":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimButton_vue_vue_type_style_index_0_id_644bc4a4_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a0e7");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimButton_vue_vue_type_style_index_0_id_644bc4a4_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimButton_vue_vue_type_style_index_0_id_644bc4a4_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "24fb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ "3fec":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7e70");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("d29493fc", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "499e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ addStylesClient; });

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "4a38":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "img[data-v-6067bd3e]{display:block}.loader[data-v-6067bd3e]{max-width:24px!important}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "6749":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4a38");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("b0c90370", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "68dc":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h14v14H0z\"></path><path d=\"M2.207 1.649 7 .583l4.793 1.066c.267.059.457.295.457.569v5.826a3.5 3.5 0 0 1-1.559 2.912L7 13.416l-3.691-2.46A3.5 3.5 0 0 1 1.75 8.044V2.218c0-.274.19-.51.457-.57zm.71 1.037v5.358c0 .78.39 1.508 1.039 1.94L7 12.015l3.044-2.03a2.333 2.333 0 0 0 1.04-1.94V2.686L7 1.779l-4.083.907zM7 6.416A1.458 1.458 0 1 1 7 3.5a1.458 1.458 0 0 1 0 2.917zM4.39 9.334a2.625 2.625 0 0 1 5.22 0H4.39z\" fill=\"#00AFA1\"></path></g></svg>"

/***/ }),

/***/ "75d0":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "*[data-v-644bc4a4],[data-v-644bc4a4]:after,[data-v-644bc4a4]:before{-webkit-box-sizing:border-box;box-sizing:border-box}.bim-btn[data-v-644bc4a4]{--text-color:#fff;--primary-color:#00afa1;--primary-color-hover:#06baab;--primary-color-active:#02a497;--box-shadow-color:rgba(0,175,161,0.2);display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border:none;background-color:var(--primary-color);color:var(--text-color);border-radius:4px;font-weight:700;white-space:nowrap;font-size:14px;line-height:1.36;-webkit-box-shadow:0 10px 10px 0 var(--box-shadow-color);box-shadow:0 10px 10px 0 var(--box-shadow-color);outline:none;-webkit-transition:.2s;transition:.2s;cursor:pointer}.bim-btn i[data-v-644bc4a4]{margin-right:4px}.bim-btn i[data-v-644bc4a4]:before{color:var(--text-color)}.bim-btn[data-v-644bc4a4]:hover{-webkit-box-shadow:0 30px 30px 0 var(--box-shadow-color);box-shadow:0 30px 30px 0 var(--box-shadow-color);background-color:var(--primary-color-hover)}.bim-btn[data-v-644bc4a4]:active{-webkit-box-shadow:none;box-shadow:none;background-color:var(--primary-color-active)}.bim-btn--big[data-v-644bc4a4]{height:54px;padding:18px 60px}.bim-btn--normal[data-v-644bc4a4]{height:42px;padding:12px 34px}.bim-btn--small[data-v-644bc4a4]{height:36px;font-size:12px;padding:8px 24px}.bim-btn--square[data-v-644bc4a4]{width:42px;height:42px;padding:0}.bim-btn--square.bim-btn--big[data-v-644bc4a4]{width:54px;height:54px}.bim-btn--square.bim-btn--small[data-v-644bc4a4]{width:36px;height:36px}.bim-btn--square i[data-v-644bc4a4]{margin:0}.bim-btn--square[data-v-644bc4a4]:active,.bim-btn--square[data-v-644bc4a4]:hover{opacity:1}.bim-btn--rounded[data-v-644bc4a4]{width:40px;height:40px;padding:0;border-radius:50%}.bim-btn--rounded.bim-btn--big[data-v-644bc4a4]{width:54px;height:54px}.bim-btn--rounded.bim-btn--small[data-v-644bc4a4]{width:36px;height:36px}.bim-btn--rounded i[data-v-644bc4a4]{margin:0}.bim-btn--luxury[data-v-644bc4a4]{--primary-color:#ff9126;--primary-color-hover:#ff9d3e;--primary-color-active:#f48820;--box-shadow-color:rgba(255,145,38,0.2)}.bim-btn--white[data-v-644bc4a4]{--text-color:#00afa1;--primary-color:#fff;--primary-color-hover:#f6f6f6;--primary-color-active:#eee;--box-shadow-color:none}.bim-btn--gray[data-v-644bc4a4]{--text-color:#4d4d4d;--primary-color:#eee;--primary-color-hover:#f6f6f6;--primary-color-active:#e6e6e6;--box-shadow-color:none}.bim-btn--darkgray[data-v-644bc4a4]{--text-color:#fff;--primary-color:#4d4d4d;--primary-color-hover:#5b5b5b;--primary-color-active:#444;--box-shadow-color:none}.bim-btn--red[data-v-644bc4a4]{--primary-color:#e44545;--primary-color-hover:#f65959;--primary-color-active:#d43838;--box-shadow-color:rgba(228,69,69,0.2)}.bim-btn--lightred[data-v-644bc4a4]{--text-color:#e44545;--primary-color:#fff;--primary-color-hover:rgba(228,69,69,0.1);--primary-color-active:rgba(228,69,69,0.25);--box-shadow-color:none}.bim-btn--outline[data-v-644bc4a4]{position:relative;top:-1px;border:1px solid var(--primary-color);background:transparent;color:var(--primary-color);--box-shadow-color:none;-webkit-transition:all .2s,color 0s;transition:all .2s,color 0s}.bim-btn--outline[data-v-644bc4a4]:hover{border:1px solid var(--primary-color-hover);color:#fff}.bim-btn--noshadow[data-v-644bc4a4]{--box-shadow-color:none}.bim-custom-color[data-v-644bc4a4],.bim-custom-color[data-v-644bc4a4]:hover{background-color:var(--propscolor);-webkit-box-shadow:none;box-shadow:none}.bim-custom-color[data-v-644bc4a4]:hover{opacity:.9}.bim-btn.disabled[data-v-644bc4a4]{opacity:.4;-webkit-box-shadow:none;box-shadow:none}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "7de2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("a543");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("ba38be8a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "7e70":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".text__main[data-v-7355df6c]{font-size:18px;font-weight:400;line-height:1.44;letter-spacing:normal}.text__main.bold[data-v-7355df6c]{font-weight:700}@media (max-width:575.98px){.text__main.adaptive[data-v-7355df6c]{font-size:16px;line-height:1.33}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "7f0e":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jsUri
 * https://github.com/derek-watson/jsUri
 *
 * Copyright 2013, Derek Watson
 * Released under the MIT license.
 *
 * Includes parseUri regular expressions
 * http://blog.stevenlevithan.com/archives/parseuri
 * Copyright 2007, Steven Levithan
 * Released under the MIT license.
 */

 /*globals define, module */

(function(global) {

  var re = {
    starts_with_slashes: /^\/+/,
    ends_with_slashes: /\/+$/,
    pluses: /\+/g,
    query_separator: /[&;]/,
    uri_parser: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@\/]*)(?::([^:@]*))?)?@)?(\[[0-9a-fA-F:.]+\]|[^:\/?#]*)(?::(\d+|(?=:)))?(:)?)((((?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
  };

  /**
   * Define forEach for older js environments
   * @see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/forEach#Compatibility
   */
  if (!Array.prototype.forEach) {
    Array.prototype.forEach = function(callback, thisArg) {
      var T, k;

      if (this == null) {
        throw new TypeError(' this is null or not defined');
      }

      var O = Object(this);
      var len = O.length >>> 0;

      if (typeof callback !== "function") {
        throw new TypeError(callback + ' is not a function');
      }

      if (arguments.length > 1) {
        T = thisArg;
      }

      k = 0;

      while (k < len) {
        var kValue;
        if (k in O) {
          kValue = O[k];
          callback.call(T, kValue, k, O);
        }
        k++;
      }
    };
  }

  /**
   * unescape a query param value
   * @param  {string} s encoded value
   * @return {string}   decoded value
   */
  function decode(s) {
    if (s) {
        s = s.toString().replace(re.pluses, '%20');
        s = decodeURIComponent(s);
    }
    return s;
  }

  /**
   * Breaks a uri string down into its individual parts
   * @param  {string} str uri
   * @return {object}     parts
   */
  function parseUri(str) {
    var parser = re.uri_parser;
    var parserKeys = ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "isColonUri", "relative", "path", "directory", "file", "query", "anchor"];
    var m = parser.exec(str || '');
    var parts = {};

    parserKeys.forEach(function(key, i) {
      parts[key] = m[i] || '';
    });

    return parts;
  }

  /**
   * Breaks a query string down into an array of key/value pairs
   * @param  {string} str query
   * @return {array}      array of arrays (key/value pairs)
   */
  function parseQuery(str) {
    var i, ps, p, n, k, v, l;
    var pairs = [];

    if (typeof(str) === 'undefined' || str === null || str === '') {
      return pairs;
    }

    if (str.indexOf('?') === 0) {
      str = str.substring(1);
    }

    ps = str.toString().split(re.query_separator);

    for (i = 0, l = ps.length; i < l; i++) {
      p = ps[i];
      n = p.indexOf('=');

      if (n !== 0) {
        k = decode(p.substring(0, n));
        v = decode(p.substring(n + 1));
        pairs.push(n === -1 ? [p, null] : [k, v]);
      }

    }
    return pairs;
  }

  /**
   * Creates a new Uri object
   * @constructor
   * @param {string} str
   */
  function Uri(str) {
    this.uriParts = parseUri(str);
    this.queryPairs = parseQuery(this.uriParts.query);
    this.hasAuthorityPrefixUserPref = null;
  }

  /**
   * Define getter/setter methods
   */
  ['protocol', 'userInfo', 'host', 'port', 'path', 'anchor'].forEach(function(key) {
    Uri.prototype[key] = function(val) {
      if (typeof val !== 'undefined') {
        this.uriParts[key] = val;
      }
      return this.uriParts[key];
    };
  });

  /**
   * if there is no protocol, the leading // can be enabled or disabled
   * @param  {Boolean}  val
   * @return {Boolean}
   */
  Uri.prototype.hasAuthorityPrefix = function(val) {
    if (typeof val !== 'undefined') {
      this.hasAuthorityPrefixUserPref = val;
    }

    if (this.hasAuthorityPrefixUserPref === null) {
      return (this.uriParts.source.indexOf('//') !== -1);
    } else {
      return this.hasAuthorityPrefixUserPref;
    }
  };

  Uri.prototype.isColonUri = function (val) {
    if (typeof val !== 'undefined') {
      this.uriParts.isColonUri = !!val;
    } else {
      return !!this.uriParts.isColonUri;
    }
  };

  /**
   * Serializes the internal state of the query pairs
   * @param  {string} [val]   set a new query string
   * @return {string}         query string
   */
  Uri.prototype.query = function(val) {
    var s = '', i, param, l;

    if (typeof val !== 'undefined') {
      this.queryPairs = parseQuery(val);
    }

    for (i = 0, l = this.queryPairs.length; i < l; i++) {
      param = this.queryPairs[i];
      if (s.length > 0) {
        s += '&';
      }
      if (param[1] === null) {
        s += param[0];
      } else {
        s += param[0];
        s += '=';
        if (typeof param[1] !== 'undefined') {
          s += encodeURIComponent(param[1]);
        }
      }
    }
    return s.length > 0 ? '?' + s : s;
  };

  /**
   * returns the first query param value found for the key
   * @param  {string} key query key
   * @return {string}     first value found for key
   */
  Uri.prototype.getQueryParamValue = function (key) {
    var param, i, l;
    for (i = 0, l = this.queryPairs.length; i < l; i++) {
      param = this.queryPairs[i];
      if (key === param[0]) {
        return param[1];
      }
    }
  };

  /**
   * returns an array of query param values for the key
   * @param  {string} key query key
   * @return {array}      array of values
   */
  Uri.prototype.getQueryParamValues = function (key) {
    var arr = [], i, param, l;
    for (i = 0, l = this.queryPairs.length; i < l; i++) {
      param = this.queryPairs[i];
      if (key === param[0]) {
        arr.push(param[1]);
      }
    }
    return arr;
  };

  /**
   * removes query parameters
   * @param  {string} key     remove values for key
   * @param  {val}    [val]   remove a specific value, otherwise removes all
   * @return {Uri}            returns self for fluent chaining
   */
  Uri.prototype.deleteQueryParam = function (key, val) {
    var arr = [], i, param, keyMatchesFilter, valMatchesFilter, l;

    for (i = 0, l = this.queryPairs.length; i < l; i++) {

      param = this.queryPairs[i];
      keyMatchesFilter = decode(param[0]) === decode(key);
      valMatchesFilter = param[1] === val;

      if ((arguments.length === 1 && !keyMatchesFilter) || (arguments.length === 2 && (!keyMatchesFilter || !valMatchesFilter))) {
        arr.push(param);
      }
    }

    this.queryPairs = arr;

    return this;
  };

  /**
   * adds a query parameter
   * @param  {string}  key        add values for key
   * @param  {string}  val        value to add
   * @param  {integer} [index]    specific index to add the value at
   * @return {Uri}                returns self for fluent chaining
   */
  Uri.prototype.addQueryParam = function (key, val, index) {
    if (arguments.length === 3 && index !== -1) {
      index = Math.min(index, this.queryPairs.length);
      this.queryPairs.splice(index, 0, [key, val]);
    } else if (arguments.length > 0) {
      this.queryPairs.push([key, val]);
    }
    return this;
  };

  /**
   * test for the existence of a query parameter
   * @param  {string}  key        add values for key
   * @param  {string}  val        value to add
   * @param  {integer} [index]    specific index to add the value at
   * @return {Uri}                returns self for fluent chaining
   */
  Uri.prototype.hasQueryParam = function (key) {
    var i, len = this.queryPairs.length;
    for (i = 0; i < len; i++) {
      if (this.queryPairs[i][0] == key)
        return true;
    }
    return false;
  };

  /**
   * replaces query param values
   * @param  {string} key         key to replace value for
   * @param  {string} newVal      new value
   * @param  {string} [oldVal]    replace only one specific value (otherwise replaces all)
   * @return {Uri}                returns self for fluent chaining
   */
  Uri.prototype.replaceQueryParam = function (key, newVal, oldVal) {
    var index = -1, len = this.queryPairs.length, i, param;

    if (arguments.length === 3) {
      for (i = 0; i < len; i++) {
        param = this.queryPairs[i];
        if (decode(param[0]) === decode(key) && decodeURIComponent(param[1]) === decode(oldVal)) {
          index = i;
          break;
        }
      }
      if (index >= 0) {
        this.deleteQueryParam(key, decode(oldVal)).addQueryParam(key, newVal, index);
      }
    } else {
      for (i = 0; i < len; i++) {
        param = this.queryPairs[i];
        if (decode(param[0]) === decode(key)) {
          index = i;
          break;
        }
      }
      this.deleteQueryParam(key);
      this.addQueryParam(key, newVal, index);
    }
    return this;
  };

  /**
   * Define fluent setter methods (setProtocol, setHasAuthorityPrefix, etc)
   */
  ['protocol', 'hasAuthorityPrefix', 'isColonUri', 'userInfo', 'host', 'port', 'path', 'query', 'anchor'].forEach(function(key) {
    var method = 'set' + key.charAt(0).toUpperCase() + key.slice(1);
    Uri.prototype[method] = function(val) {
      this[key](val);
      return this;
    };
  });

  /**
   * Scheme name, colon and doubleslash, as required
   * @return {string} http:// or possibly just //
   */
  Uri.prototype.scheme = function() {
    var s = '';

    if (this.protocol()) {
      s += this.protocol();
      if (this.protocol().indexOf(':') !== this.protocol().length - 1) {
        s += ':';
      }
      s += '//';
    } else {
      if (this.hasAuthorityPrefix() && this.host()) {
        s += '//';
      }
    }

    return s;
  };

  /**
   * Same as Mozilla nsIURI.prePath
   * @return {string} scheme://user:password@host:port
   * @see  https://developer.mozilla.org/en/nsIURI
   */
  Uri.prototype.origin = function() {
    var s = this.scheme();

    if (this.userInfo() && this.host()) {
      s += this.userInfo();
      if (this.userInfo().indexOf('@') !== this.userInfo().length - 1) {
        s += '@';
      }
    }

    if (this.host()) {
      s += this.host();
      if (this.port() || (this.path() && this.path().substr(0, 1).match(/[0-9]/))) {
        s += ':' + this.port();
      }
    }

    return s;
  };

  /**
   * Adds a trailing slash to the path
   */
  Uri.prototype.addTrailingSlash = function() {
    var path = this.path() || '';

    if (path.substr(-1) !== '/') {
      this.path(path + '/');
    }

    return this;
  };

  /**
   * Serializes the internal state of the Uri object
   * @return {string}
   */
  Uri.prototype.toString = function() {
    var path, s = this.origin();

    if (this.isColonUri()) {
      if (this.path()) {
        s += ':'+this.path();
      }
    } else if (this.path()) {
      path = this.path();
      if (!(re.ends_with_slashes.test(s) || re.starts_with_slashes.test(path))) {
        s += '/';
      } else {
        if (s) {
          s.replace(re.ends_with_slashes, '/');
        }
        path = path.replace(re.starts_with_slashes, '/');
      }
      s += path;
    } else {
      if (this.host() && (this.query().toString() || this.anchor())) {
        s += '/';
      }
    }
    if (this.query().toString()) {
      s += this.query().toString();
    }

    if (this.anchor()) {
      if (this.anchor().indexOf('#') !== 0) {
        s += '#';
      }
      s += this.anchor();
    }

    return s;
  };

  /**
   * Clone a Uri object
   * @return {Uri} duplicate copy of the Uri
   */
  Uri.prototype.clone = function() {
    return new Uri(this.toString());
  };

  /**
   * export via AMD or CommonJS, otherwise leak a global
   */
  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return Uri;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(this));


/***/ }),

/***/ "8407":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimProductCard_vue_vue_type_style_index_0_id_bcb5bf06_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7de2");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimProductCard_vue_vue_type_style_index_0_id_bcb5bf06_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimProductCard_vue_vue_type_style_index_0_id_bcb5bf06_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "93ff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextMain_vue_vue_type_style_index_0_id_7355df6c_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3fec");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextMain_vue_vue_type_style_index_0_id_7355df6c_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextMain_vue_vue_type_style_index_0_id_7355df6c_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a0e7":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("75d0");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("57358bea", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "a543":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".bim-product-card[data-v-bcb5bf06]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-radius:10px;-webkit-box-shadow:0 3px 8px 0 rgba(0,0,0,.05);box-shadow:0 3px 8px 0 rgba(0,0,0,.05);border:.5px solid #e6e6e6;background-color:#fff;text-decoration:none;overflow:hidden;cursor:pointer;-webkit-transition:all .2s;transition:all .2s;position:relative}.bim-product-card[data-v-bcb5bf06]:hover{border-color:var(--hovercolor);-webkit-box-shadow:none;box-shadow:none}.bim-product-card:hover .bim-product-card__top[data-v-bcb5bf06]{border-color:#e6e6e6}.bim-product-card:hover .bim-product-card__manufactirer-link[data-v-bcb5bf06]{opacity:1}.bim-product-card[data-v-bcb5bf06]:active{border-color:#f6f6f6;background-color:#f6f6f6}.bim-product-card .bim-product-card__top[data-v-bcb5bf06]{border-color:#eee}.bim-product-card__verified-icon[data-v-bcb5bf06]{position:absolute;right:9px;bottom:6px}.bim-product-card__verified-icon[data-v-bcb5bf06]  svg{width:14px;height:14px}.bim-product-card__top[data-v-bcb5bf06]{-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative;border-bottom:1px solid #eee;height:128px}.bim-product-card__image[data-v-bcb5bf06]{width:100px;height:100px;-o-object-fit:contain;object-fit:contain;max-width:100%;max-height:100%}.bim-product-card__manufactirer-link[data-v-bcb5bf06]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:absolute;width:24px;height:24px;right:6px;bottom:9px;opacity:.5;-webkit-transition:all .2s;transition:all .2s}.bim-product-card__manufactirer-link[data-v-bcb5bf06]:hover{opacity:1}.bim-product-card__manufactirer-link.big-wide[data-v-bcb5bf06]{width:36px;height:36px}.bim-product-card__manufactirer-image[data-v-bcb5bf06]{width:100%;height:auto}.bim-product-card__bottom[data-v-bcb5bf06]{padding:14px 8px 18px}.bim-product-card__title[data-v-bcb5bf06]{margin:0;font-size:13px;font-weight:400;line-height:1.38;letter-spacing:.19px;color:#4d4d4d;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:4;overflow:hidden;word-break:break-word}.bim-product-card--wide[data-v-bcb5bf06]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;width:100%!important;height:105px!important}.bim-product-card--wide .bim-product-card__top[data-v-bcb5bf06]{-ms-flex-negative:0;flex-shrink:0;width:105px;height:auto;border:none;border-right:1px solid #eee}.bim-product-card--wide .bim-product-card__image[data-v-bcb5bf06]{width:77px;height:77px;-o-object-fit:contain;object-fit:contain;max-width:100%;max-height:100%}.bim-product-card--wide .bim-product-card__manufactirer-link[data-v-bcb5bf06]{left:8px;bottom:8px;right:unset}.bim-product-card--wide .bim-product-card__bottom[data-v-bcb5bf06]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:14px}.bim-product-card--wide .bim-product-card__title[data-v-bcb5bf06]{margin:0 0 8px;padding:0;font-size:18px;font-weight:700;line-height:1.44;letter-spacing:normal;color:#4d4d4d;-webkit-line-clamp:2}@media screen and (max-width:767.98px){.bim-product-card--wide .bim-product-card__title[data-v-bcb5bf06]{font-size:14px}}.bim-product-card--wide .bim-product-card__category[data-v-bcb5bf06]{font-size:10px;font-weight:700;line-height:2;letter-spacing:1px;color:#4d4d4d;opacity:.5;text-transform:uppercase;margin:auto 0 0;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;overflow:hidden}@media screen and (max-width:767.98px){.bim-product-card--wide .bim-product-card__category[data-v-bcb5bf06]{font-size:8px;margin:0;-webkit-line-clamp:2}}.big-image-cnt[data-v-bcb5bf06]{position:relative;overflow:hidden}.bim-image-skelet[data-v-bcb5bf06]{width:100%;pointer-events:none;display:block;height:100%}.bim-image[data-v-bcb5bf06]{display:block;position:absolute;top:0;bottom:0;width:auto;height:100%;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.bim-text-cnt[data-v-bcb5bf06]{margin-top:20px}.big-card-title[data-v-bcb5bf06]{margin-bottom:12px;color:#4d4d4d}.big-card-desc[data-v-bcb5bf06]{overflow:hidden;color:#4d4d4d;margin-bottom:20px}.big-card-desc-text[data-v-bcb5bf06]{line-height:1.57!important;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:6;overflow:hidden;word-break:break-word}@media (min-width:767.98px){.bim-card-big[data-v-bcb5bf06]{display:-webkit-box;display:-ms-flexbox;display:flex}.big-image-cnt[data-v-bcb5bf06]{-webkit-box-flex:0.8;-ms-flex:0.8;flex:0.8}.bim-text-cnt[data-v-bcb5bf06]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-flex:1;-ms-flex:1;flex:1;margin-left:33px;margin-top:0}.big-card-title[data-v-bcb5bf06]{-webkit-box-flex:0;-ms-flex:0;flex:0;margin-bottom:14px}.big-card-desc[data-v-bcb5bf06]{-webkit-box-flex:1;-ms-flex:1;flex:1;overflow:hidden;margin-bottom:24px}.big-card-btn[data-v-bcb5bf06]{-webkit-box-flex:0;-ms-flex:0;flex:0}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "abc1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimImg_vue_vue_type_style_index_0_id_6067bd3e_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6749");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimImg_vue_vue_type_style_index_0_id_6067bd3e_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimImg_vue_vue_type_style_index_0_id_6067bd3e_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ee41":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("06a9");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("75f7b670", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/bimProductCard/bimProductCard.vue?vue&type=template&id=bcb5bf06&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.smallCard)?_c('a',_vm._b({staticClass:"bim-product-card",class:{ 'bim-product-card--wide': _vm.type === 'wide' },style:(_vm.cardStyle),attrs:{"href":_vm.link}},'a',_vm.$attrs,false),[_c('div',{staticClass:"bim-product-card__top"},[_c('bimImg',{staticClass:"bim-product-card__image",attrs:{"itemprop":"contentUrl","src":_vm.imageSrc,"alt":_vm.name,"lazy":_vm.lazyImage}}),(_vm.manufacturer.image)?_c('span',{staticClass:"bim-product-card__manufactirer-link",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.companyClicked($event)}}},[_c('bimImg',{staticClass:"bim-product-card__manufactirer-image",attrs:{"src":_vm.manufacturer.image,"alt":_vm.manufacturer.name,"lazy":_vm.lazyImage}})],1):_vm._e()],1),_c('div',{staticClass:"bim-product-card__bottom"},[_c('h5',{staticClass:"bim-product-card__title",attrs:{"itemprop":"name"}},[_vm._v(_vm._s(_vm.name))]),(_vm.type === 'wide')?_c('p',{staticClass:"bim-product-card__category"},[_vm._v(_vm._s(_vm.description))]):_vm._e()]),(_vm.showLockIcon)?_c('div',{staticClass:"bim-product-card__verified-icon",attrs:{"title":"Производитель запрашивает контакты для скачивания этой модели","width":"14px","height":"14px"},domProps:{"innerHTML":_vm._s(__webpack_require__("68dc"))}}):_vm._e()]):_c('div',_vm._b({staticClass:"bim-card-big"},'div',_vm.$attrs,false),[_c('div',{staticClass:"big-image-cnt"},[_c('img',{staticClass:"bim-image-skelet",attrs:{"src":_vm.bigWideSkelet}}),_c('bimImg',{staticClass:"bim-image",attrs:{"src":_vm.imageBigSrc,"alt":_vm.name,"lazy":_vm.lazyImage}}),(_vm.manufacturer.image)?_c('span',{staticClass:"bim-product-card__manufactirer-link big-wide",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.companyClicked($event)}}},[_c('bimImg',{staticClass:"bim-product-card__manufactirer-image",attrs:{"src":_vm.manufacturer.image,"alt":_vm.manufacturer.name,"lazy":_vm.lazyImage}})],1):_vm._e()],1),_c('div',{staticClass:"bim-text-cnt"},[_c('div',{staticClass:"big-card-title"},[_c('bim-text-main',{attrs:{"bold":true}},[_vm._v(_vm._s(_vm.name))])],1),_c('div',{staticClass:"big-card-desc"},[_c('bim-text-medium',{staticClass:"big-card-desc-text"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.description)}})])],1),(_vm.btnName)?_c('div',{staticClass:"big-card-btn"},[_c('bim-button',{attrs:{"label":_vm.btnName,"size":"l","color":_vm.borderHoverColor},on:{"click":_vm.btnClicked}})],1):_vm._e()])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/bimProductCard/bimProductCard.vue?vue&type=template&id=bcb5bf06&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form/bimButton/bimButton.vue?vue&type=template&id=644bc4a4&scoped=true&
var bimButtonvue_type_template_id_644bc4a4_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.href)?_c('a',{staticClass:"bim-btn",class:[_vm.classes, _vm.activeClass],style:(("\n    width: " + _vm.computedWidth + ";\n    height: " + _vm.computedHeight + ";\n   ")),attrs:{"href":_vm.href,"disabled":_vm.disabled}},[(_vm.icon)?_c('i',{class:_vm.icon,style:(("font-size: " + _vm.iconSize + "px; color: " + _vm.textColor + "; -webkit-text-fill-color: " + _vm.textColor))}):_vm._e(),(!this.$slots.default && !_vm.square && !_vm.rounded)?_c('span',{style:(_vm.textColor ? ("color: " + _vm.textColor + ";") : '')},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._t("default")],2):_c('button',{staticClass:"bim-btn",class:[_vm.classes, _vm.activeClass],style:(_vm.style),on:{"click":_vm.btnClicked}},[(_vm.icon)?_c('i',{class:_vm.icon,style:(("font-size: " + _vm.iconSize + "px; color: " + _vm.textColor + "; -webkit-text-fill-color: " + _vm.textColor))}):_vm._e(),(!this.$slots.default && !_vm.square && !_vm.rounded)?_c('span',{style:(_vm.textColor ? ("color: " + _vm.textColor + ";") : '')},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._t("default")],2)}
var bimButtonvue_type_template_id_644bc4a4_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/form/bimButton/bimButton.vue?vue&type=template&id=644bc4a4&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form/bimButton/bimButton.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var bimButtonvue_type_script_lang_js_ = ({
  name: 'bimButton',
  props: {
    /**
     * Делает кнопку не активной
     */
    disabled: Boolean,
    /**
     * Делает кнопку не активной
     */
    makeClickOnDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Ширина кнопки. Если число без величины, будет px.
     */
    width: [String, Number],
    /**
     * Высота кнопки. Если число без величины, будет px.
     */
    height: [String, Number],
    /**
     * Ссылка кнопки
     */
    href: String,
    /**
     * Цвет кнопки
     * @values luxury, gray, darkgray, red, lightred, white
     */
    color: {
      type: String,
      default: 'primary'
    },
    /**
     * Цвет текста в любом формате. hex, rgba и т.д.
     */
    textColor: String,
    /**
     * Название класса активной ссылки/кнопки
     */
    activeClass: String,
    /**
     * Квадратная кнопка. Если включено, то label игнорируется
     */
    square: Boolean,
    /**
     * Круглая кнопка. Если включено, то label игнорируется
     */
    rounded: Boolean,
    /**
     * Кнопка с обводкой.
     * Адекватно работает только на ярких и темных кнопках.
     */
    outline: Boolean,
    /**
     * Отключение тени
     */
    noshadow: Boolean,
    /**
     * Текст кнопки
     */
    label: {
      type: String,
      default: 'Кнопка'
    },
    /**
     * Название класса иконки
     */
    icon: String,
    /**
     * Размер иконки в пикселях.
     */
    iconSize: {
      type: [String, Number],
      default: 16
    },
    /**
     * Размер кнопки.
     * @values s - маленькая кнопка, m - средняя кнопка, l - большая кнопка
     */
    size: {
      type: String,
      default: 'm',
      validator: function validator() {
        return ['s', 'm', 'l'];
      }
    },
    /**
     * Изменение фона кнопки в любом формате (hex, rgb и т.д.)
     */
    background: {
      type: String
    }
  },
  computed: {
    classes: function classes() {
      return {
        'bim-btn--big': this.size === 'l',
        'bim-btn--normal': this.size === 'm',
        'bim-btn--small': this.size === 's',
        'bim-btn--square': this.square,
        'bim-btn--rounded': this.rounded,
        'bim-btn--luxury': this.color === 'luxury',
        'bim-btn--white': this.color === 'white',
        'bim-btn--gray': this.color === 'gray',
        'bim-btn--darkgray': this.color === 'darkgray',
        'bim-btn--red': this.color === 'red',
        'bim-btn--lightred': this.color === 'lightred',
        'bim-btn--outline': this.outline,
        'bim-btn--noshadow': this.noshadow,
        'bim-custom-color': this.isCustomColor,
        disabled: this.disabled
      };
    },
    computedHeight: function computedHeight() {
      if (+this.height) {
        return this.height + 'px';
      } else {
        return this.height;
      }
    },
    computedWidth: function computedWidth() {
      if (+this.width) {
        return this.width + 'px';
      } else {
        return this.width;
      }
    },
    isCustomColor: function isCustomColor() {
      return !~['primary', 'luxury', 'gray', 'darkgray', 'red', 'lightred', 'white'].indexOf(this.color);
    },
    style: function style() {
      var style = {
        width: this.computedWidth,
        height: this.computedHeight,
        'background-color': this.background
      };
      if (this.isCustomColor) {
        style['--propscolor'] = this.color;
      }
      return style;
    }
  },
  methods: {
    btnClicked: function btnClicked(e) {
      if (this.disabled && !this.makeClickOnDisabled) {
        return;
      }
      this.$emit('click', e);
    }
  }
});
// CONCATENATED MODULE: ./src/components/form/bimButton/bimButton.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimButton_bimButtonvue_type_script_lang_js_ = (bimButtonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/form/bimButton/bimButton.vue?vue&type=style&index=0&id=644bc4a4&prod&lang=scss&scoped=true&
var bimButtonvue_type_style_index_0_id_644bc4a4_prod_lang_scss_scoped_true_ = __webpack_require__("1e73");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/form/bimButton/bimButton.vue






/* normalize component */

var component = normalizeComponent(
  bimButton_bimButtonvue_type_script_lang_js_,
  bimButtonvue_type_template_id_644bc4a4_scoped_true_render,
  bimButtonvue_type_template_id_644bc4a4_scoped_true_staticRenderFns,
  false,
  null,
  "644bc4a4",
  null
  
)

/* harmony default export */ var bimButton = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextMain/bimTextMain.vue?vue&type=template&id=7355df6c&scoped=true&lang=html&
var bimTextMainvue_type_template_id_7355df6c_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"text__main",class:{ bold: _vm.bold, adaptive: _vm.adaptive }},[_vm._t("default")],2)}
var bimTextMainvue_type_template_id_7355df6c_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/text/bimTextMain/bimTextMain.vue?vue&type=template&id=7355df6c&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextMain/bimTextMain.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//

/* harmony default export */ var bimTextMainvue_type_script_lang_js_ = ({
  name: 'bimTextMain',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'div'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/text/bimTextMain/bimTextMain.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimTextMain_bimTextMainvue_type_script_lang_js_ = (bimTextMainvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/text/bimTextMain/bimTextMain.vue?vue&type=style&index=0&id=7355df6c&prod&lang=scss&scoped=true&
var bimTextMainvue_type_style_index_0_id_7355df6c_prod_lang_scss_scoped_true_ = __webpack_require__("93ff");

// CONCATENATED MODULE: ./src/components/text/bimTextMain/bimTextMain.vue






/* normalize component */

var bimTextMain_component = normalizeComponent(
  bimTextMain_bimTextMainvue_type_script_lang_js_,
  bimTextMainvue_type_template_id_7355df6c_scoped_true_lang_html_render,
  bimTextMainvue_type_template_id_7355df6c_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "7355df6c",
  null
  
)

/* harmony default export */ var bimTextMain = (bimTextMain_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextMedium/bimTextMedium.vue?vue&type=template&id=0f65208b&scoped=true&lang=html&
var bimTextMediumvue_type_template_id_0f65208b_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"text__medium",class:{ bold: _vm.bold }},[_vm._t("default")],2)}
var bimTextMediumvue_type_template_id_0f65208b_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/text/bimTextMedium/bimTextMedium.vue?vue&type=template&id=0f65208b&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextMedium/bimTextMedium.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//

/* harmony default export */ var bimTextMediumvue_type_script_lang_js_ = ({
  name: 'bimTextMedium',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'div'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/text/bimTextMedium/bimTextMedium.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimTextMedium_bimTextMediumvue_type_script_lang_js_ = (bimTextMediumvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/text/bimTextMedium/bimTextMedium.vue?vue&type=style&index=0&id=0f65208b&prod&lang=scss&scoped=true&
var bimTextMediumvue_type_style_index_0_id_0f65208b_prod_lang_scss_scoped_true_ = __webpack_require__("054a");

// CONCATENATED MODULE: ./src/components/text/bimTextMedium/bimTextMedium.vue






/* normalize component */

var bimTextMedium_component = normalizeComponent(
  bimTextMedium_bimTextMediumvue_type_script_lang_js_,
  bimTextMediumvue_type_template_id_0f65208b_scoped_true_lang_html_render,
  bimTextMediumvue_type_template_id_0f65208b_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "0f65208b",
  null
  
)

/* harmony default export */ var bimTextMedium = (bimTextMedium_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/bimImg/bimImg.vue?vue&type=template&id=6067bd3e&scoped=true&lang=html&
var bimImgvue_type_template_id_6067bd3e_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"img",class:{ loader: !_vm.srcImg },attrs:{"src":_vm.srcImg ? _vm.srcImg : _vm.srcLoader}})}
var bimImgvue_type_template_id_6067bd3e_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/bimImg/bimImg.vue?vue&type=template&id=6067bd3e&scoped=true&lang=html&

// CONCATENATED MODULE: ./src/components/core/lazy-load-image.js
/* harmony default export */ var lazy_load_image = ({
  props: {
    /**
     * Использовать асинхронную подгрузку картинки по мере скрола
     */
    lazy: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      lazyImgSrcKey: '',
      // по какому ключу лежит src картинки
      srcImg: '',
      srcLoader: "data:image/svg+xml,%3Csvg width='34px' height='33px' viewBox='0 0 34 33' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-189.000000, -132.000000)'%3E%3Crect id='Rectangle' fill='%23B4B4B4' x='192' y='135' width='12' height='12'%3E%3C/rect%3E%3Crect id='Rectangle' fill='%23DADADA' x='208' y='135' width='12' height='12'%3E%3C/rect%3E%3Crect id='Rectangle' fill='%23E6E6E6' x='192' y='151' width='12' height='12'%3E%3C/rect%3E%3Crect id='Rectangle' fill='%23F6F6F6' x='208' y='151' width='12' height='12'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E",
      timeoutIndex: null,
      isLazy: this.lazy
    };
  },
  created: function created() {
    if (!this.isLazy) {
      this.formSrcImg();
    }
  },
  mounted: function mounted() {
    if (this.isLazy) {
      window.addEventListener('resize', this.onScrollResize);
      window.addEventListener('scroll', this.onScrollResize);
      this.onScrollResize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isLazy) {
      window.removeEventListener('resize', this.onScrollResize);
      window.removeEventListener('scroll', this.onScrollResize);
    }
  },
  methods: {
    formSrcImg: function formSrcImg() {
      this.srcImg = this.srcImage();
    },
    srcImage: function srcImage() {
      return this[this.lazyImgSrcKey] || '';
    },
    loadOriginalImage: function loadOriginalImage() {
      var _this = this;
      var src = this.srcImage();
      if (!src) {
        return;
      }
      var image = new Image();
      image.onload = function () {
        _this.srcImg = src;
        _this.emitLazyEvent();
      };
      image.src = src;
    },
    emitLazyEvent: function emitLazyEvent() {
      var _this2 = this;
      var emitLazyEvent = function emitLazyEvent() {
        _this2.$emit('lazyLoaded');
        if (_this2.$globalEvents) {
          _this2.$globalEvents.$emit('wResize');
        }
      };
      this.$nextTick(function () {
        setTimeout(emitLazyEvent, 100);
        setTimeout(emitLazyEvent, 250);
      });
    },
    onScrollResize: function onScrollResize() {
      var _this3 = this;
      if (this.srcImg || this.timeoutIndex !== null) {
        return;
      }
      var height = window.innerHeight;
      var offsetHeight = 20; // дополнительный отступ (чтоб картинка грузилась чуть раньше)
      var img = this.$refs.img;
      if (!img) {
        return;
      }
      var bounding = img.getBoundingClientRect();
      var isHidden = function isHidden(bounding) {
        var props = ['bottom', 'height', 'left', 'right', 'top', 'width', 'x', 'y'];
        var hidden = true;
        for (var i in props) {
          // eslint-disable-next-line no-prototype-builtins
          if (props.hasOwnProperty(i)) {
            var prop = props[i];
            if (bounding[prop] !== 0) {
              hidden = false;
            }
          }
        }
        return hidden;
      };
      if (bounding.top < height + offsetHeight && !isHidden(bounding)) {
        this.timeoutIndex = true;
        this.loadOriginalImage();
        return;
      }
      this.timeoutIndex = setTimeout(function () {
        _this3.timeoutIndex = null;
      }, 100);
    }
  },
  watch: {
    isLazy: function isLazy(value) {
      if (!value) {
        this.formSrcImg();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/bimImg/bimImg.vue?vue&type=script&lang=js&
//
//
//
//


/* harmony default export */ var bimImgvue_type_script_lang_js_ = ({
  name: 'BimImg',
  mixins: [lazy_load_image],
  props: {
    /**
     * src изображения
     */
    src: {
      type: [String],
      default: ''
    }
  },
  data: function data() {
    return {
      lazyImgSrcKey: 'src' // по какому ключу лежит src картинки
    };
  }
});
// CONCATENATED MODULE: ./src/components/ui/bimImg/bimImg.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimImg_bimImgvue_type_script_lang_js_ = (bimImgvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/ui/bimImg/bimImg.vue?vue&type=style&index=0&id=6067bd3e&prod&lang=scss&scoped=true&
var bimImgvue_type_style_index_0_id_6067bd3e_prod_lang_scss_scoped_true_ = __webpack_require__("abc1");

// CONCATENATED MODULE: ./src/components/ui/bimImg/bimImg.vue






/* normalize component */

var bimImg_component = normalizeComponent(
  bimImg_bimImgvue_type_script_lang_js_,
  bimImgvue_type_template_id_6067bd3e_scoped_true_lang_html_render,
  bimImgvue_type_template_id_6067bd3e_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "6067bd3e",
  null
  
)

/* harmony default export */ var bimImg = (bimImg_component.exports);
// EXTERNAL MODULE: ./node_modules/jsuri/Uri.js
var Uri = __webpack_require__("7f0e");
var Uri_default = /*#__PURE__*/__webpack_require__.n(Uri);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/bimProductCard/bimProductCard.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var bimProductCardvue_type_script_lang_js_ = ({
  name: 'bimProductCard',
  components: {
    bimButton: bimButton,
    bimTextMain: bimTextMain,
    bimTextMedium: bimTextMedium,
    bimImg: bimImg
  },
  props: {
    /**
     * src изображения модели
     */
    image: {
      type: String
    },
    /**
     * Использовать асинхронную подгрузку картинки по мере скрола
     */
    lazyImage: {
      type: Boolean,
      default: false
    },
    /**
     * Наименование модели
     */
    name: {
      type: String,
      required: true
    },
    /**
     * Описание модели
     */
    description: {
      type: String
    },
    /**
     * Наименование кнопки
     */
    btnName: {
      type: String
    },
    /**
     * Ссылка на модель
     */
    link: {
      type: String
    },
    /**
     * Размер Карточки
     */
    type: {
      type: String,
      default: 'card',
      validator: function validator(value) {
        return ['card', 'wide', 'big-wide'].indexOf(value) !== -1;
      }
    },
    /**
     * Ширина карточки. Если число без величины, будет px.
     */
    width: {
      type: [String, Number],
      default: 140
    },
    /**
     * Высота карточки. Если число без величины, будет px.
     */
    height: {
      type: [String, Number],
      default: 232
    },
    /**
     * Производитель
     */
    manufacturer: {
      type: Object,
      default: function _default() {
        return {};
      },
      prop: {
        link: String,
        // ссылка
        name: String,
        // наименование
        image: String // картинка
      }
    },

    /**
     * Цвет бордера при наведении на карточку
     */
    borderHoverColor: {
      type: String,
      default: '#00afa1'
    },
    /**
     * Показывать иконку замка на карточке модели
     */
    showLockIcon: Boolean
  },
  data: function data() {
    return {
      bigWideSkelet: 'data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAABkAAD/4QMuaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA2LjAtYzAwMiA3OS4xNjQzNTIsIDIwMjAvMDEvMzAtMTU6NTA6MzggICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCAyMS4xIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjc5QTM0MDZGOUY1NTExRUFBQzBBRUE3ODdBRUVEOTEyIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjc5QTM0MDcwOUY1NTExRUFBQzBBRUE3ODdBRUVEOTEyIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzlBMzQwNkQ5RjU1MTFFQUFDMEFFQTc4N0FFRUQ5MTIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NzlBMzQwNkU5RjU1MTFFQUFDMEFFQTc4N0FFRUQ5MTIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7/7gAOQWRvYmUAZMAAAAAB/9sAhAABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAgICAgICAgICAgIDAwMDAwMDAwMDAQEBAQEBAQIBAQICAgECAgMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwP/wAARCAADAAUDAREAAhEBAxEB/8QASgABAAAAAAAAAAAAAAAAAAAACgEBAAAAAAAAAAAAAAAAAAAAABABAAAAAAAAAAAAAAAAAAAAABEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AfwD/2Q=='
    };
  },
  computed: {
    imageSrc: function imageSrc() {
      return this.formImage('200x-');
    },
    imageBigSrc: function imageBigSrc() {
      return this.formImage('300x-');
    },
    smallCard: function smallCard() {
      return ~['card', 'wide'].indexOf(this.type);
    },
    cardStyle: function cardStyle() {
      return {
        width: this.computedWidth,
        height: this.computedHeight,
        '--hovercolor': this.borderHoverColor
      };
    },
    computedHeight: function computedHeight() {
      if (+this.height) {
        return this.height + 'px';
      } else {
        return this.height;
      }
    },
    computedWidth: function computedWidth() {
      if (+this.width) {
        return this.width + 'px';
      } else {
        return this.width;
      }
    }
  },
  methods: {
    formImage: function formImage(size) {
      return new Uri_default.a(this.image).addQueryParam('size', size).toString();
    },
    btnClicked: function btnClicked() {
      this.$emit('btnClicked');
    },
    companyClicked: function companyClicked(e) {
      e.stopPropagation();
      e.preventDefault();
      if (!this.manufacturer) {
        return;
      }
      if (!this.manufacturer.link) {
        return;
      }
      window.location = this.manufacturer.link;
    }
  }
});
// CONCATENATED MODULE: ./src/components/ui/bimProductCard/bimProductCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimProductCard_bimProductCardvue_type_script_lang_js_ = (bimProductCardvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/ui/bimProductCard/bimProductCard.vue?vue&type=style&index=0&id=bcb5bf06&prod&lang=scss&scoped=true&
var bimProductCardvue_type_style_index_0_id_bcb5bf06_prod_lang_scss_scoped_true_ = __webpack_require__("8407");

// CONCATENATED MODULE: ./src/components/ui/bimProductCard/bimProductCard.vue






/* normalize component */

var bimProductCard_component = normalizeComponent(
  bimProductCard_bimProductCardvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "bcb5bf06",
  null
  
)

/* harmony default export */ var bimProductCard = (bimProductCard_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (bimProductCard);



/***/ })

/******/ })["default"];
//# sourceMappingURL=bimProductCard.common.js.map